<script setup lang="ts">
import { computed } from 'vue';
import ColumnMapping from '@/components/ColumnMapping.vue';
import { cn } from '@/utils/utils';
import { TRACK_MATCHING_FOREIGN_KEY_OVERRIDES } from '@/config/trackMatchingForeignKeys';
import { useTrackMatchingStore } from '@/stores/trackMatchingStore';
import { isFieldHighlightedForRow } from '@/trackMatching/trackMatchingPayload';

const props = defineProps<{
  field: string;
  dataType: string;
  data: Record<string, unknown> & { live_track_id: string | number; source: string; id: string | number };
  foreignKeyOverrides?: Record<string, Record<string, string>>;
}>();

const trackMatchingStore = useTrackMatchingStore();

const liveTrackRow = computed(() =>
  trackMatchingStore.getLiveTrackRow(props.data.live_track_id)
);

/** Read-only cell; accent when the field is included in a queued Link or Apply ISRC action. */
const isFieldHighlighted = computed(() =>
  isFieldHighlightedForRow(
    props.data,
    props.field,
    liveTrackRow.value
  )
);
</script>

<template>
  <div class="w-full">
    <div
      :class="cn(
        'w-full min-w-0 rounded-sm px-0.5',
        // Keep the yellow band visible even when the source field is empty — empty raw_ddex
        // values still overwrite the live track on link, so the user needs the indicator to
        // make it obvious that 'overwrite with nothing' is queued (SAU-178).
        isFieldHighlighted ? 'bg-accent text-accent-foreground min-h-5' : ''
      )"
    >
      <ColumnMapping
        :data="data"
        :field="field"
        :dataType="dataType"
        :effectiveEntityId="'LiveTrack'"
        :foreignKeyOverrides="foreignKeyOverrides ?? TRACK_MATCHING_FOREIGN_KEY_OVERRIDES"
      />
    </div>
  </div>
</template>
